import axios from "axios";

import {
  SET_TOTAL_MONEY,
  RESET_TOTAL_MONEY,
  RESET_TOTAL_TIME,
  SET_TOTAL_TIME,
  SET_CHOOSEN_ITEMS,
  SET_MASTER,
  SET_MASTER_LIST,
  AUTH_SUCCES,
  AUTH_LOGOUT,
  PHONES_SET,
  MODAL_SET,
  SET_MODAL_CONTENT,
} from "./actionTypes";

import { API_KEY } from "../../utils/api";

export function setTotalMasterList(arr) {
  return (dispatch) => {
    dispatch(setMasterList(arr));
  };
}

export function setMasterList(arr) {
  return {
    type: SET_MASTER_LIST,
    masterList: arr,
  };
}

export function calculateTotalMoney(num) {
  return (dispatch) => {
    dispatch(setTotalMoney(num));
  };
}

export function setTotalMoney(num) {
  return {
    type: SET_TOTAL_MONEY,
    totalMoney: num,
  };
}

export function setModalWindowContent(txt) {
  return {
    type: SET_MODAL_CONTENT,
    payload: txt,
  };
}

export function setTotalTime(num) {
  return {
    type: SET_TOTAL_TIME,
    totalTime: num,
  };
}

export function resetTotalMoney() {
  return {
    type: RESET_TOTAL_MONEY,
    totalMoney: 0,
  };
}

export function calculateTotalTime(num) {
  return (dispatch) => {
    dispatch(setTotalTime(num));
  };
}

export function resetTotalTime() {
  return {
    type: RESET_TOTAL_TIME,
    totalTime: 0,
  };
}

export function changeChoosenItems(item) {
  return (dispatch) => {
    dispatch(setChoosenItems(item));
  };
}

export function setChoosenItems(item) {
  return {
    type: SET_CHOOSEN_ITEMS,
    choosenItems: item,
  };
}

export function setMaster(num) {
  return {
    type: SET_MASTER,
    master: num,
  };
}

export function changeMaster(num) {
  return (dispatch) => {
    dispatch(setMaster(num));
  };
}

export function auth(email, password) {
  return async (dispatch) => {
    const authData = {
      email,
      password,
      returnSecureToken: true,
    };

    const response = await axios.post(
      `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${API_KEY}`,
      authData
    );

    const data = response.data;

    const expirationDate = new Date(
      new Date().getTime() + data.expiresIn * 1000
    );

    localStorage.setItem("token", data.idToken);
    localStorage.setItem("userId", data.localId);
    localStorage.setItem("expirationDate", expirationDate);

    dispatch(authSuccess(data.idToken));
    dispatch(autoLogout(data.expiresIn));
  };
}

export function autoLogout(time) {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, time * 1000);
  };
}

export function authSuccess(token) {
  return {
    type: AUTH_SUCCES,
    token,
  };
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("expirationDate");
  return {
    type: AUTH_LOGOUT,
  };
}

export function autoLogin() {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    if (!token) {
      dispatch(logout());
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      if (expirationDate <= new Date()) {
        dispatch(logout());
      } else {
        dispatch(authSuccess(token));
        dispatch(
          autoLogout((expirationDate.getTime() - new Date().getTime()) / 1000)
        );
      }
    }
  };
}

export function phonesSetTotal(arr) {
  return (dispatch) => {
    dispatch(phonesSet(arr));
  };
}

export function phonesSet(arr) {
  return {
    type: PHONES_SET,
    phones: arr,
  };
}

export function setModalWindow(bool) {
  return {
    type: MODAL_SET,
    isModal: bool,
  };
}
